
// --
// FACEBOOK SHARE
// --
// class that shares shareurl via facebook dialog
//

// --
// USAGE
// --
//
// data-component="share-facebook" data-component-options='{"shareURL":"[url-to-share]"}'
//
// "shareURL" is the site url to share ie http://uniondigital.co.nz
//


import Component_share_base from './_share-base'

export default class Component_share_facebook extends Component_share_base {

  constructor(el, options) {

    super(el, $.extend(true, {

      'windowTarget':'http://www.facebook.com/sharer.php?u=',
      'windowName':'facebook share',
      'windowParams':'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'

    }, options), 'component');

  }

}





/** WEBPACK FOOTER **
 ** ./components/share-facebook.js
 **/